<template>
  <div class="media-explorer">
    <v-dialog
      scrollable
      :value.sync="value"
      @click:outside="$emit('input', false)"
      @input="$emit('input', false)"
      content-class="media-display-list-dialog"
    >
      <media-display-list
        ref="mediaList"
        @input="$emit('input', false)"
        :multiple="multiple"
        :format="format"
        :list="list"
        @selected="selectedItems"
        :list-selection="listSelection"
        :close-selection="closeSelection"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MediaDisplayList from "./MediaDisplayList.vue";
export default {
  components: { MediaDisplayList },
  name: "MediaExplorer",
  props: {
    value: {
      default: false
    },
    multiple: {
      default: false
    },
    format: {
      default: "files"
    },
    list: {
      default: "grid"
    },
    listSelection: {
      default: true
    },
    /**
     * Selected event tetiklendikten sonra seçimi tekrar sıfırlar 
     */
    closeSelection: {
      default: false
    },
  },
  data: () => ({}),
  computed: {
    ...mapState({
      mediaList: state => state.Media.MediaList.mediaList
    })
  },
  methods: {
    selectedItems(items) {
      this.$emit("selected", items);
    }
  },
  mounted() {
    let self = this,
      preload = [
        new Promise(resolve => {
          resolve(self.$store.dispatch("Media/getAcceptFilesList"));
        })
      ];

    preload.push(
      new Promise(resolve => {
        resolve(self.$store.dispatch("Media/getAcceptBaseImages"));
      })
    );

    preload.push(
      new Promise(resolve => {
        resolve(self.$store.dispatch("Media/getMediaListTypes"));
      })
    );

    Promise.all(preload).then(() => {
      this.mediaListComponent = MediaList;
    });
  }
};
</script>